import { useParams } from "react-router-dom";
import { useState } from "react";
import { useGoals } from "./hooks/useGoals";
import { getGoalParameters } from "./utils/parameters";
import MonthYearFilter from "./utils/MothYearFilter";
import { Trash } from "lucide-react";
import GoalProgress from "./GoalProgress";

export default function GoalsView() {

  const { empId } = useParams();
  const employeeId = Number(empId);

  const now = new Date();
  const defaultMonth = String(now.getMonth() + 1);
  const defaultYear = String(now.getFullYear());

  const [ month, setMonth ] = useState(defaultMonth);
  const [ year, setYear ] = useState(defaultYear);

  const filters = {
    employeeId,
    month,
    year,
  };

  const { data: goal, isLoading } = useGoals(filters);

  const parameters = goal ? getGoalParameters(goal) : undefined;

  const clearFilter = () => {
    setMonth("");
    setYear("");
  };

  return (
    <div className="p-2 max-w-[80%] mx-auto">
      <div>
        <div className="rounded-lg flex gap-4 justify-center items-center p-3 ">
          <MonthYearFilter
            month={month}
            year={year}
            onChange={({ month, year }) => {
              setMonth(month);
              setYear(year);
            }}
          />
          <button
            className="rounded-full border p-2 hover:border-red-500 hover:text-red-500 bg-red-50 shadow-md transition-all ease-in-out duration-300"
            onClick={clearFilter}
          >
            <Trash className="size-3.5" />
          </button>
        </div>

        {isLoading ? (
          <div className="w-full flex flex-col items-center justify-center min-h-40">
            <p className="my-4">Loading Goals...</p>
            <span className="loading loading-spinner loading-lg"></span>
          </div>
        ) : (
          <GoalProgress parameters={parameters} />
        )}
      </div>
    </div>
  );
}
